import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "custom-toast-body text-bg-secondary cow-toast-info" }
const _hoisted_3 = { class: "me-auto" }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-secondary",
  "data-bs-dismiss": "toast"
}, " Undo ", -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close me-1",
  "data-bs-dismiss": "toast",
  "aria-label": "Close"
}, null, -1 /* HOISTED */)

import { ref, onMounted } from 'vue';
import Toast from 'bootstrap/js/dist/toast';
import { useUid } from '@app/composables/useUid';

type UndoDeleteFn = () => void;


export default /*#__PURE__*/_defineComponent({
  __name: 'undoDeleteToast',
  props: {
    message: {},
    undoDelete: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const uid = useUid();

const sentUndo = ref(false);

function undoClicked() {
  if (!sentUndo.value) {
    sentUndo.value = true;
    props.undoDelete();
    // TODO hide the toast?
  }
}

onMounted(() => {
  const toast = document.getElementById(`undo-delete-toast-${uid}`);
  if (toast) {
    // eslint-disable-next-line no-new
    new Toast(toast).show();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `undo-delete-toast-${_unref(uid)}`,
    class: "toast fade m-auto mb-1 mb-md-3 ms-md-auto me-md-3",
    role: "status",
    "aria-live": "polite",
    "aria-atomic": "true",
    "data-bs-delay": "15000"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("strong", _hoisted_3, _toDisplayString(_ctx.message), 1 /* TEXT */),
      _createElementVNode("form", {
        onSubmit: _withModifiers(undoClicked, ["prevent"])
      }, _hoisted_6, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_4),
      _hoisted_7
    ])
  ], 8 /* PROPS */, _hoisted_1))
}
}

})